import * as React from 'react'
import * as _ from "lodash";
import { Calendar, momentLocalizer } from 'react-big-calendar'
import * as moment from "moment";
import { CALENDAR_MAX, CALENDAR_MIN } from "../../utils/DateUtils";
import StyleUtils from '../../utils/StyleUtils';
import { ScheduleElement } from '../../models/ScheduleElement';
moment.locale("nb");

export interface IUkeplanPrintStudentProps {
    scheduleElements: any;
    ukeplanelementsstudent: any;
    student: any;
    selectedDate:any;
    week: any;
    year: any;
    includeSchedule: boolean;
}

export default class UkeplanPrintStudent extends React.Component<IUkeplanPrintStudentProps> {
    constructor(props) {
        super(props);
    }

    filterEvents() {
        // Returns an empty array if there are ScheduleElements yet
        if (_.isEmpty(this.props.scheduleElements)) {
            return [];
        }

        let values = _.values(this.props.scheduleElements).sort((a, b) => {
            if (a.Title < b.Title) { return -1; }
            if (a.Title > b.Title) { return 1; }
            return 0;
        });

        if (this.props.student.AssignmentGroup) {

            values = values.filter(se => se.TilretteleggingsgruppeId == null ||  se.TilretteleggingsgruppeId == 0 || se.TilretteleggingsgruppeId == this.props.student.AssignmentGroup.Id);
        }


        return values;
    }

    renderCustomEvent = (scheduleElement: ScheduleElement) => {
        return (
            <div className="custom-event-container">
                <div className="custom-event-label-print">
                    <span className="custom-event-label-time">
                        {scheduleElement.Start ? moment(scheduleElement.Start).format("HH:mm") : ""} - {scheduleElement.End ? moment(scheduleElement.End).format("HH:mm") : ""}
                    </span>
                </div>
                <div style={{ color: 'black', wordWrap: "break-word", wordBreak: "break-word" }}>{scheduleElement.Title}</div>
            </div>
        )
    }

    eventStyleGetter(se: ScheduleElement) {
        return { style: new StyleUtils().getCalendarScheduleStylePrint() };
    }

    render() {
        const localizer = momentLocalizer(moment);
        return (
            <div style={{ pageBreakAfter: "always", marginBottom: "4rem" }}>
                <h2>{this.props.student.Name} - Uke {this.props.week} {this.props.year}</h2>
                <div style={{ display: this.props.includeSchedule ? "block" : "none" }}>
                    <Calendar
                        localizer={localizer}
                        events={this.filterEvents()}
                        min={CALENDAR_MIN}
                        max={CALENDAR_MAX}
                        defaultView={"work_week"}
                        eventPropGetter={this.eventStyleGetter}
                        views={["work_week"]}
                        // onSelectEvent={this.onSelectEvent}
                        components={{
                            toolbar: (props) => <span></span>,
                            event: ({ event }) => (
                                this.renderCustomEvent(event)
                            )
                        }}
                        dayLayoutAlgorithm={"no-overlap"}
                        titleAccessor="Title"
                        startAccessor="Start"
                        endAccessor="End"
                        date={this.props.selectedDate}
                    />
                </div>
                {this.props.ukeplanelementsstudent.map((e) => {
                    return (
                        <>
                            <div className="printItem">
                                <div className="printContent">
                                    <h3 className="printFagTittel">{e.Title}</h3>
                                </div>
                            </div>
                            {e.News && e.News.map((n) => {
                                return (
                                    <div className="printItem">
                                        <div className="printContentCol">
                                            <ul className="printList">
                                                <li className="printFagTittel">{n.Title}</li>
                                                <li className="printListContent" dangerouslySetInnerHTML={{ __html: n.TextRaw }} />
                                                {n.Teacher &&
                                                    <div>
                                                        <li className="printListContent">{n.Teacher}</li>
                                                    </div>
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                )
                            })}
                            {e.StudentTexts && e.StudentTexts.map((text) => {
                                return (
                                    <div style={{ margin: "1rem 0 2rem 0" }}>
                                        <div className="printContentCol">
                                            <ul className="printList">
                                                {text.Theme && (
                                                    <li className="printListContent printFagTittel">{text.Theme}</li>
                                                )}
                                                {text.EvalElements && text.EvalElements.length > 0 && (
                                                    <li className="printListContent evalHeader">Vurdering:</li>
                                                )}
                                                {text.EvalElements.map((evalTekst) => {
                                                    return (<li className="printListContent">{evalTekst}</li>)
                                                })}
                                                {text.Goal && (
                                                    <>
                                                        <li className="printListContent goalHeader">Mål:</li>
                                                        <li className="printListContent" dangerouslySetInnerHTML={{ __html: text.Goal }} />
                                                    </>
                                                )}
                                                {/* {text.Link && (
                                                                                <>
                                                                                    <li className="printListContent linkHeader">Lenke</li>
                                                                                    <li className="printListContent printLenke">{text.Link}</li>
                                                                                </>
                                                                            )} */}
                                            </ul>
                                        </div>
                                        <div className="printContentCol">
                                            {text.TextonPremRaw && (
                                                <ul className="printList">
                                                    <li className="printListContent goalHeader">Arbeid på skolen:</li>
                                                    <li className="printListContent" dangerouslySetInnerHTML={{ __html: text.TextonPremRaw }} />
                                                </ul>
                                            )}
                                        </div>
                                        <div className="printContentCol">
                                            {text.TextRaw && (
                                                <ul className="printList">
                                                    <li className="printListContent goalHeader">Arbeid hjemme:</li>
                                                    <li className="printListContent" dangerouslySetInnerHTML={{ __html: text.TextRaw }} />
                                                </ul>
                                            )}
                                        </div>
                                        {!text.HideDeadline &&
                                            <div className="printContentCol">
                                                <ul className='printList'>
                                                    <li className="printListTitle" style={{ width: "100%" }}>Frist:</li>
                                                    <li className="printListContent">{text.DateText ? text.DateText : text.Date}</li>
                                                </ul>
                                            </div>
                                        }
                                    </div>
                                )
                            })}
                            <div className="printContentTask" >
                                {e.StudentTasks && e.StudentTasks.map((task) => {
                                    return (
                                        <div style={{ margin: "1rem 0rem 2rem 0rem" }}>
                                            <div className="printContentCol">

                                                <ul className="printList printTask" style={{ marginTop: "0px" }}>
                                                    <li className="printListContent printFagTittel">
                                                        {task.WsTask.Name}
                                                        {/* . Logg inn på Zokrates for å gjennomføre oppgaven. */}
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="printContentCol">
                                                <ul className="printList" style={{ marginTop: "0px" }}>
                                                    {task.WsTask.Text && (
                                                        <>
                                                            <li className="printListContent goalHeader">
                                                                Oppgavetekst:
                                                            </li>
                                                            <li className='printListContent' dangerouslySetInnerHTML={{ __html: task.WsTask.Text }} />
                                                        </>
                                                    )}

                                                    {task.WsTask.Goal && (
                                                        <>
                                                            <li className="printListContent goalHeader">Mål:</li>
                                                            <li className="printListContent" dangerouslySetInnerHTML={{ __html: task.WsTask.Goal }} />
                                                        </>
                                                    )}

                                                    {/* {task.WsTask.GrepCodeList && task.WsTask.GrepCodeList.length > 0 && (
                                                                                <div style={{margin: "1rem 0rem"}}>
                                                                                    <li className="printListTitle goalHeader"  style={{fontWeight: "bold", width: "100%"}}>Kompetansemål:</li>
                                                                                    <ul className="printList">
                                                                                        {task.WsTask.GrepCodeList.map(grp => {
                                                                                            return <li className="printListContent">
                                                                                                {grp.KMID} - {grp.LPID}: {grp.GrepTekst}
                                                                                            </li>
                                                                                        })}
                                                                                    </ul>
                                                                                </div>
                                                                            )} */}

                                                    {/* {task.WsTask.Link && (
                                                                                <>
                                                                                    <li className="printListContent linkHeader">Lenke</li>
                                                                                    <li className="printListContent printLenke">{task.WsTask.Link}</li>
                                                                                </>
                                                                            )} */}

                                                    {!task.WsTask.HideDeadline &&
                                                        <>
                                                            <li className="printListTitle" style={{ width: "100%" }}>Frist:</li>
                                                            <li className="printListContent">{task.WsTask.Deadlinetekst}</li>
                                                        </>
                                                    }

                                                </ul>
                                            </div>


                                        </div>
                                    )
                                })}
                            </div>
                        </>
                    )
                })}
            </div>
        )
    }
}
